import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import featureFlagStore from "@/store/featureFlagStore";

// LQC-2847 - the OP's blocks are cancelled or replaced at these statuses.
export const OFFLOAD_RISK_OP_BLOCKED_STATUSES: string[] = [
  ExecutionStrategyStatus.Cancelled,
  ExecutionStrategyStatus.ReCreated,
];

// LQC-2576 - /Trade/OffloadRisk is keyed on one execution request, but the menu
// item sits on the ES row. The RP's row carries its own ER id; fall back to its
// single counterparty entry, which is that same request.
// LQC-2847 - the OP sends no ER id: the backend takes the OP path on its absence.
export function resolveOffloadExecutionRequestId(
  tradeData: any,
): number | undefined {
  if (tradeData?.role == "OP") return undefined;
  if (tradeData?.executionRequestId != undefined) {
    return Number(tradeData.executionRequestId);
  }
  const counterparties = tradeData?.executionRequestCounterParties;
  if (counterparties?.length === 1) {
    return counterparties[0]?.executionRequestId;
  }
  return undefined;
}

// RP at any status (cancelled included) but needs its ER id; OP at any status
// bar OFFLOAD_RISK_OP_BLOCKED_STATUSES.
// Read at call time (menu open), never at module scope - see CLAUDE.md cycles.
export function canOffloadRisk(tradeData: any): boolean {
  if (!featureFlagStore.getState().offloadRisk) return false;
  if (!tradeData?.esid) return false;
  if (tradeData.role == "OP") {
    return !OFFLOAD_RISK_OP_BLOCKED_STATUSES.includes(tradeData.status);
  }
  if (tradeData.role == "RP") {
    return resolveOffloadExecutionRequestId(tradeData) != undefined;
  }
  return false;
}
